import { registerComponent } from "@eusoft/webapp-core/Component";
import { EmptyView } from "@eusoft/webapp-framework";
import { forModel } from "@eusoft/webapp-jsx";
import { Content, contentInfo, type ViewNode } from "@eusoft/webapp-ui";


export interface IErrorPageArgs {
    message?: ViewNode;
}

export class ErrorPage extends Content<IErrorPageArgs> {
    constructor() {

        super();

        this.init(ErrorPage, {
            title: "error",
            style: ["panel"],
            body: forModel(this, m => <>     
                <EmptyView iconName="error" message={m.message} />
            </>)
        });
    }

    override async onLoadAsync(args: IErrorPageArgs) {
        this.message = args.message ?? new URLSearchParams(window.location.search).get("message");
        return true;
    }

    hideContext = true;

    message: ViewNode;

    static override info = contentInfo({
        name: "error",
        transition: "reload",
        factory: () => new ErrorPage(),
        route: "/error"
    });
}

registerComponent(ErrorPage, "ErrorPage");